module.exports = __webpack_public_path__ + "img/3.001b0240.png";